<template>
  <el-rate :max="1" v-model="rating" @change="changeHandler" />
</template>

<script>
  import { Rate } from 'element-ui';

  export default {
    name: 'BlastHighlight',

    props: {
      value: { default: false, type: Boolean },
    },

    components: {
      'el-rate': Rate,
    },

    computed: {
      rating: {
        get() {
          return this.value ? 1 : 0;
        },
        set() {
        },
      },
    },

    methods: {
      changeHandler() {
        this.$emit('input', !this.value);
      },
    },
  };
</script>
